import { getAivo, aivoChatSendMessage } from "./utils";
import { IFeedbackCount, FEEDBACK, CALL_TO_ACTION_MESSAGES } from "./constants";

export function showAdviserButtonForTwoBadFeedbacks(value: boolean): any {
  let feedbackCount: IFeedbackCount =
    getAivo()?.user?.get()?.[FEEDBACK.PROPERTY];

  if (value === true) feedbackCount.good++;
  else feedbackCount.bad++;

  if (feedbackCount.bad >= FEEDBACK.BAD?.ADVISER?.MAXIMUM) {
    aivoChatSendMessage(CALL_TO_ACTION_MESSAGES.ADVISER);
    feedbackCount.bad = 0;
  }
  getAivo()?.user?.set(FEEDBACK.PROPERTY, feedbackCount);
}
